import authStoreGetters from '@constans/store/auth/authStoreGetters';
const getters = {
    [authStoreGetters.GET_ACCESS_TOKEN]: (state) => state.access_token,
    [authStoreGetters.GET_LOGIN_ERR_MSG]: (state) => state.login_err_msg
};
export default getters;
